import clsx from "clsx";
import type { FunctionComponent } from "react";
import React, {
  useCallback,
  useEffect,
} from "react";
import {
  m,
  useAnimationFrame,
  useMotionValue,
} from "framer-motion";
import { useAnimateSize } from "~/utils/dom/useAnimateSize";
import { useWindowSize } from "~/utils/dom/useWindowSize";

interface FlowRowProps {
  children: React.ReactNode;
  isRev?: boolean;
}

const FlowRow: FunctionComponent<
  FlowRowProps
> = ({ children, isRev }) => {
  const { observeRef, width } = useAnimateSize();
  const { width: windowWidth } = useWindowSize();
  const {
    observeRef: observeRefChild,
    width: widthChild,
  } = useAnimateSize();
  const motionX = useMotionValue(0);
  const [isMouseOver, setIsMouseOver] =
    React.useState(false);
  const prevTime = React.useRef(0);
  const speed = React.useRef(0.1);
  const loop = useCallback(
    (time: number) => {
      /* if (isMouseOver) {
        prevTime.current = time;
        return;
      } */
      const timeDiff = time - prevTime.current;
      if (isMouseOver) {
        if (speed.current > 0.01) {
          speed.current -= 0.003;
        }
      } else {
        if (speed.current < 0.1) {
          speed.current += 0.003;
        }
      }
      const newV = -(
        -motionX.get() +
        timeDiff *
          speed.current *
          (isRev ? -1 : 1)
      );
      motionX.set(
        !isRev
          ? newV < -width
            ? 0
            : newV
          : newV > width
            ? 0
            : newV,
      );
      prevTime.current = time;
    },
    [isMouseOver, isRev, motionX, width],
  );
  useAnimationFrame(loop);
  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };
  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const [num, setNum] = React.useState(10);

  useEffect(() => {
    const clamp = (
      num: number,
      min: number,
      max: number,
    ) => {
      return Math.min(Math.max(num, min), max);
    };

    setNum(
      clamp(
        Math.ceil(windowWidth / widthChild),
        1,
        30,
      ),
    );
  }, [widthChild, windowWidth]);

  return (
    <div
      className={clsx(
        "flex",
        "shrink-0",
        "overflow-hidden",
        isRev && "flex-row-reverse",
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <m.div
        className={clsx(
          "flex",
          "shrink-0",
          //"animate-[flowX_20s_infinite_linear]",
          isRev && "flex-row-reverse",
        )}
        style={{ x: motionX }}
      >
        {Array.from({ length: 2 }).map((_, i) => {
          return (
            <div
              key={i}
              className={clsx(
                "flex",
                "shrink-0",
                isRev && "flex-row-reverse",
              )}
              ref={observeRef}
            >
              {Array.from({ length: num }).map(
                (_, i) => {
                  return (
                    <div
                      key={"compo-" + i}
                      className=""
                      ref={observeRefChild}
                    >
                      {children}
                    </div>
                  );
                },
              )}
            </div>
          );
        })}
      </m.div>
    </div>
  );
};

export default FlowRow;
